import { render, staticRenderFns } from "./workerCertificateDoctorPraCount.vue?vue&type=template&id=61a9fb9a&scoped=true&"
import script from "./workerCertificateDoctorPraCount.vue?vue&type=script&lang=js&"
export * from "./workerCertificateDoctorPraCount.vue?vue&type=script&lang=js&"
import style0 from "./workerCertificateDoctorPraCount.vue?vue&type=style&index=0&id=61a9fb9a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a9fb9a",
  null
  
)

export default component.exports